import type { SVGProps } from "react";

export const Posthog = (props: SVGProps<SVGSVGElement>) => (
  <svg
    id="Layer_1"
    version="1.1"
    viewBox="0 114.15 512.1 283.65"
    x="0"
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    y="0"
    {...props}
  >
    <title>Posthog</title>
    <path
      d="M116.2 272c-3.9 7.9-15.2 7.9-19.1 0l-9.4-18.8c-1.5-3-1.5-6.5 0-9.5l9.4-18.8c3.9-7.9 15.2-7.9 19.1 0l9.4 18.8c1.5 3 1.5 6.5 0 9.5zm0 106.7c-3.9 7.9-15.2 7.9-19.1 0l-9.4-18.8c-1.5-3-1.5-6.5 0-9.5l9.4-18.8c3.9-7.9 15.2-7.9 19.1 0l9.4 18.8c1.5 3 1.5 6.5 0 9.5z"
      style={{ fill: "#1d4aff" }}
    />
    <path
      d="M0 338.2c0-9.5 11.5-14.3 18.2-7.5l48.9 48.9c6.7 6.7 2 18.2-7.5 18.2H10.7C4.8 397.8 0 393 0 387.1zm0-51.5c0 2.8 1.1 5.5 3.1 7.5l100.4 100.4c2 2 4.7 3.1 7.5 3.1h55.2c9.5 0 14.3-11.5 7.5-18.2L18.2 224c-6.7-6.7-18.2-2-18.2 7.5zM0 180c0 2.8 1.1 5.5 3.1 7.5l207.1 207.1c2 2 4.7 3.1 7.5 3.1h55.2c9.5 0 14.3-11.5 7.5-18.2L18.2 117.3c-6.7-6.7-18.2-2-18.2 7.5zm106.7 0c0 2.8 1.1 5.5 3.1 7.5l192 192c6.7 6.7 18.2 2 18.2-7.5v-55.2c0-2.8-1.1-5.5-3.1-7.5l-192-192c-6.7-6.7-18.2-2-18.2 7.5zm124.8-62.7c-6.7-6.7-18.2-2-18.2 7.5V180c0 2.8 1.1 5.5 3.1 7.5l85.3 85.3c6.7 6.7 18.2 2 18.2-7.5v-55.2c0-2.8-1.1-5.5-3.1-7.5z"
      style={{ fill: "#f9bd2b" }}
    />
    <path d="M453.7 339.5 353.3 239.1c-6.7-6.7-18.2-2-18.2 7.5v140.5c0 5.9 4.8 10.7 10.7 10.7h155.6c5.9 0 10.7-4.8 10.7-10.7v-12.8c0-5.9-4.8-10.6-10.6-11.4-18.1-2.3-34.8-10.4-47.8-23.4m-67.4 24.2c-9.4 0-17.1-7.6-17.1-17.1 0-9.4 7.6-17.1 17.1-17.1 9.4 0 17.1 7.6 17.1 17.1 0 9.4-7.7 17.1-17.1 17.1" />
    <path
      d="M0 387.1c0 5.9 4.8 10.7 10.7 10.7h48.9c9.5 0 14.3-11.5 7.5-18.2l-48.9-48.9c-6.7-6.7-18.2-2-18.2 7.5zm106.7-181.3-88.5-88.5c-6.7-6.7-18.2-2-18.2 7.5V180c0 2.8 1.1 5.5 3.1 7.5L106.6 291v-85.2zM18.2 224c-6.7-6.7-18.2-2-18.2 7.5v55.2c0 2.8 1.1 5.5 3.1 7.5l103.5 103.5v-85.3z"
      style={{ fill: "#1d4aff" }}
    />
    <path
      d="M213.3 210.2c0-2.8-1.1-5.5-3.1-7.5l-85.3-85.3c-6.7-6.7-18.2-2-18.2 7.5V180c0 2.8 1.1 5.5 3.1 7.5L213.3 291zM106.7 397.8h59.6c9.5 0 14.3-11.5 7.5-18.2l-67.1-67.1zm0-192v80.9c0 2.8 1.1 5.5 3.1 7.5l103.5 103.5v-80.9c0-2.8-1.1-5.5-3.1-7.5z"
      style={{ fill: "#f54e00" }}
    />
  </svg>
);

export default Posthog;
